import { Category } from '../types/converter';

export const categories: Category[] = [
  {
    id: 'common',
    name: 'Common Converters',
    icon: 'Ruler',
    converters: [
      'angle',
      'area',
	  'case',
      'currency',
      'dataStorage',
      'energy',
      'force',
      'fuelConsumption',
      'length',
      'numbers',
      'power',
      'pressure',
      'speed',
      'temperature',
      'time',
      'volumeDry',
      'volume',
      'weightAndMass',
    ],
    description: 'Our most popular and widely used unit converters. From length and weight for everyday tasks to currency and temperature for travel, these tools cover all your basic conversion needs with high precision.',
    faq: [
      {
        question: 'What are the most common unit conversions?',
        answer: 'The most frequent conversions include Length (meters to feet), Weight (kilograms to pounds), and Temperature (Celsius to Fahrenheit).'
      },
      {
        question: 'How accurate are these converters?',
        answer: 'Our converters use standard international constants and high-precision floating-point math to ensure results are accurate for both casual and professional use.'
      }
    ],
  },
  {
    id: 'electricity',
    name: 'Electricity Converters',
    icon: 'Zap',
    converters: [
      'charge',
      'current',
      'electricConductance',
      'electricConductivity',
      'electricFieldStrength',
      'electricPotential',
      'electricResistance',
      'electricResistivity',
      'electrostaticCapacitance',
      'inductance',
      'linearChargeDensity',
      'linearCurrentDensity',
      'surfaceChargeDensity',
      'surfaceCurrentDensity',
      'volumeChargeDensity',
    ],
    description: 'A comprehensive suite of electrical measurement converters. Essential for electrical engineers, students, and hobbyists working with voltage, resistance, capacitance, and other electrical properties.',
    faq: [
      {
        question: 'What units are used for electric potential?',
        answer: 'The standard unit for electric potential is the Volt (V). Our converter also supports kilovolts, millivolts, and statvolts.'
      }
    ],
  },
  {
    id: 'engineering',
    name: 'Engineering Converters',
    icon: 'Wrench',
    converters: [
      'accelerationAngular',
      'acceleration',
      'density',
      'momentOfForce',
      'momentOfInertia',
      'specificVolume',
      'torque',
      'velocityAngular',
    ],
    description: 'Specialized tools for mechanical and civil engineering calculations. Convert complex units like moment of inertia, torque, and angular acceleration with ease.',
    faq: [
      {
        question: 'How do I convert torque?',
        answer: 'Torque is typically measured in Newton-meters (Nm) or Pound-feet (lb-ft). Use our Engineering converter to switch between metric and imperial torque units instantly.'
      }
    ]
  },
  {
    id: 'fluids',
    name: 'Fluids Converters',
    icon: 'Droplets',
    converters: [
      'concentrationMolar',
      'concentrationSolution',
      'flowMass',
      'flowMolar',
      'flow',
      'massFluxDensity',
      'permeability',
      'surfaceTension',
      'viscosityDynamic',
      'viscosityKinematic',
    ],
  },
  {
    id: 'heat',
    name: 'Heat Converters',
    icon: 'Thermometer',
    converters: [
      'fuelEfficiencyMass',
      'fuelEfficiencyVolume',
      'heatDensity',
      'heatFluxDensity',
      'heatTransferCoefficient',
      'specificHeatCapacity',
      'temperatureInterval',
      'thermalConductivity',
      'thermalExpansion',
      'thermalResistance',
    ],
  },
  {
    id: 'light',
    name: 'Light Converters',
    icon: 'Sun',
    converters: [
      'digitalImageResolution',
      'frequencyWavelength',
      'illumination',
      'luminance',
      'luminousIntensity',
    ],
  },
  {
    id: 'magnetism',
    name: 'Magnetism Converters',
    icon: 'Magnet',
    converters: [
      'magneticFieldStrength',
      'magneticFlux',
      'magneticFluxDensity',
      'magnetomotiveForce',
    ],
  },
  
  {
    id: 'radiology',
    name: 'Radiology Converters',
    icon: 'Radio',
    converters: [
      'radiation',
      'radiationAbsorbedDose',
      'radiationActivity',
      'radiationExposure',
    ],
  },
    {
    id: 'other',
    name: 'Other Converters',
    icon: 'Package',
    converters: [
      'dataTransfer',
      'prefixes',
      'sound',
      'typography',
	    'volumeLumber',
    ],
  },
];
